import {
  ANNOUNCEMENT_LIMITS,
  type AnnouncementAudience,
  type AnnouncementDraft,
} from '../../../../lib/notifications/announcements';

/** The form's own state: the date is the date input's "YYYY-MM-DD". */
export interface AnnouncementFormValues {
  title: string;
  body: string;
  linkLabel: string;
  linkUrl: string;
  audience: AnnouncementAudience;
  showUntilDate: string;
}

export const DAY_MS = 24 * 60 * 60 * 1000;

const pad = (n: number): string => String(n).padStart(2, '0');

/** A time as the date input's value, in the portal user's own time zone. */
export const toDateInput = (epochMs: number): string => {
  const d = new Date(epochMs);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** The last second of that day, in the portal user's own time zone. */
export const endOfDay = (dateInput: string): number => {
  const parsed = new Date(`${dateInput}T23:59:59`);
  return Number.isNaN(parsed.getTime()) ? NaN : parsed.getTime();
};

export const emptyFormValues = (now = Date.now()): AnnouncementFormValues => ({
  title: '',
  body: '',
  linkLabel: '',
  linkUrl: '',
  audience: 'everyone',
  showUntilDate: toDateInput(now + ANNOUNCEMENT_LIMITS.defaultShowDays * DAY_MS),
});

export const toDraft = (values: AnnouncementFormValues): AnnouncementDraft => ({
  title: values.title,
  body: values.body,
  linkLabel: values.linkLabel,
  linkUrl: values.linkUrl,
  audience: values.audience,
  showUntil: endOfDay(values.showUntilDate),
});
